




















import { Component, Vue } from 'vue-property-decorator'
import { State, namespace } from 'vuex-class'

import { windowOpen } from '@common/loan-act/util'
import { RUN_SIDE } from '@common/loan-act/env'
import { integralDrawEnhance } from '$services/act'
import { ACT_CODE, AWARD_URL } from '$utils/act-config'

const actModule = namespace('act')

@Component({
  components: {
  }
})
export default class RollerSquare extends Vue {
  @State(state => state.common.loginState) isLogin!: boolean
  @actModule.Getter usableIntegral!: number
  @actModule.Getter integralCode!: string
  @actModule.Getter status!: string
  // @actModule.Getter awardRespBOS!: string
  @actModule.Action getIntegral!: (params?: any) => Promise<any>
  list = [
    { prize_name: '500元携程卡', img: require('../../assets/img/prize/xc.png') },
    { prize_name: '50元京东E卡', img: require('../../assets/img/prize/jdk.png') },
    { prize_name: '安热沙防晒乳', img: require('../../assets/img/prize/ans.png') },
    { prize_name: '旅行洗漱套装', img: require('../../assets/img/prize/tz.png') },
    { prize_name: '8元现金红包', img: require('../../assets/img/prize/repack.png') },
    { prize_name: '随手记笔记本', img: require('../../assets/img/prize/books.png') },
    { prize_name: '1元现金红包', img: require('../../assets/img/prize/repack.png') },
    { prize_name: '谢谢参与', img: require('../../assets/img/prize/thanks.png') },
  ] // 奖品列表
  currentIndex = 0 // 当前转动到哪个位置，第一次起点位置0,对应页面item1位置
  count = 8 // 总共有多少个位置
  times = 0 // 转动跑格子次数,
  cycle = 20 // 转动基本次数：即至少需要转动多少次再进入抽奖环节
  speed = 200 // 初始转动速度
  timer = 0 // 转动定时器
  prizeIndex = -1 // 中奖位置，接口返回
  prizeData: any = {
    prizeCode: String,
    prizeValue: String
  } // 中奖信息
  mounted() {
  }
  // 点击开始抽奖
  move() {
    if (RUN_SIDE === 'h5' || this.usableIntegral === 0) {
      return
    }
    this.$buryPoint.report('act/KEY_5')
    if (this.status === 'over') {
      this.$ssvue.toast.show('活动已结束~')
    } else if (this.status === 'unopen') {
      this.$ssvue.toast.show('活动未开始~')
    } else if (!this.isLogin) {
      this.$store.dispatch('normalLogin')
    } else if (this.times !== 0) {
      this.$ssvue.toast.show('正在抽奖中')
    } else {
      this.speed = 200
      this.draw()
      this.startRoll()
    }
  }
  cashCode1 = 'XJlkOBkOdy'
  cashCode2 = 'XJ2QjOQ9ig'
  draw() {
    const p = {
      integralCode: this.integralCode,
      actCode: ACT_CODE,
      syncSW: true,
      suid: ''
    }
    integralDrawEnhance(p)
      .then((res: any) => {
        if (res.result) {
          const { prizeCode } = res.awardList[0]
          // 中奖位置赋值，跑马灯最终停留位置，这里实际位置需要-1
          if (prizeCode === this.cashCode1) {
            this.prizeIndex = 7 - 1 // 1元现金红包
            this.prizeData.prizeValue = 1
          } else if (prizeCode === this.cashCode2) {
            this.prizeIndex = 5 - 1 // 8元现金红包
            this.prizeData.prizeValue = 8
          } else {
            this.prizeIndex = 8 - 1 // 谢谢参与
            this.prizeData.prizeValue = 0
          }
          this.prizeData.prizeCode = prizeCode
          // this.startRoll() // 执行抽奖
        } else {
          this.$ssvue.toast.show('抽奖失败')
        }
      })
  }
  // 开始转动
  startRoll() {
    this.times += 1 // 转动次数
    this.oneRoll() // 转动过程调用的每一次转动方法，这里是第一次调用初始化
    this.endRoll()
  }
  // 每一次转动
  oneRoll() {
    let { currentIndex } = this // 当前转动到哪个位置
    const count = 8 // 总共有多少个位置
    currentIndex += 1
    if (currentIndex > count - 1) {
      currentIndex = 0
    }
    this.currentIndex = currentIndex
  }
  increment = 0
  endRoll() {
    // const increment = 1 // 增量圈数
    if (this.prizeIndex === -1) {
      this.increment++
    }
    // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
    if (this.times > this.cycle + this.increment && this.prizeIndex === this.currentIndex) {
      clearTimeout(this.timer) // 清除转动定时器
      this.times = 0 // 转动跑格子次数初始化为0，可以开始下次抽奖
      this.prizeIndex = -1
      this.increment = 0
      setTimeout(() => {
        this.drawPrizeShow()
      }, 1000)
    } else {
      if (this.times < this.cycle - 10) {
        this.speed -= 5 // 加快转动速度
      } else {
        this.speed += 20 // 抽奖即将结束，放慢转动速度
      }
      clearTimeout(this.timer) // 清除转动定时器
      this.timer = setTimeout(this.startRoll, this.speed) // 开始转动
    }
  }
  drawPrizeShow() {
    const { prizeCode, prizeValue } = this.prizeData
    const self: any = this
    this.$store.dispatch('act/getIntegral')

    if (prizeCode === this.cashCode1) {
      self.$pop.show({
        type: 'prize',
        prizeValue,
        onBtnClick() {
          windowOpen(AWARD_URL)
        }
      })
    } else if (prizeCode === this.cashCode2) {
      self.$pop.show({
        type: 'prize',
        prizeValue,
        onBtnClick() {
          windowOpen(AWARD_URL)
        }
      })
    } else {
      self.$pop.show({
        type: 'empty',
        closeIcon: false,
        onBtnClick() {
        }
      })
    }
  }
}
